import React from "react";
import { useHistory } from "react-router";
import {
  DataFlowsDashboardPageContent,
  HR_DATA_FLOWS_DASHBOARD_CONFIG,
  useDataFlowCollectionGroupsCompletion,
} from "../../../data-map/data-flows/DataFlowsDashboardPage";
import { usePrimaryOrganizationId } from "../../../../hooks";
import { useEmploymentCollectionGroups } from "../../../../hooks/useCollectionGroups";
import { Routes } from "../../../../root/routes";
import { EmployeePageWrapper } from "./EmployeePageWrapper";

export function HRDataFlowsDashboard() {
  const history = useHistory();
  const orgId = usePrimaryOrganizationId();
  const [groups, , refreshGroups] = useEmploymentCollectionGroups(
    orgId,
    /* onlyUseSettled = */ true,
  );
  const { allComplete } = useDataFlowCollectionGroupsCompletion({
    config: HR_DATA_FLOWS_DASHBOARD_CONFIG,
    groups,
  });

  return (
    <EmployeePageWrapper
      selectedTabKey="hr-data-flows"
      nextOnClick={() => history.push(Routes.hrCenter.hrDataMap.employeeSources)}
      nextDisabled={!allComplete}
      nextDisabledTooltip="Complete all collection groups to continue."
    >
      <DataFlowsDashboardPageContent
        config={HR_DATA_FLOWS_DASHBOARD_CONFIG}
        groups={groups}
        refreshGroups={refreshGroups}
        includePageWrapper={false}
      />
    </EmployeePageWrapper>
  );
}
